import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HmpgComponent } from './hmpg/hmpg.component';
import { ZylyComponent } from './zyly/zyly.component';
import { ZytdComponent } from './zytd/zytd.component';
import { JcalComponent } from './jcal/jcal.component';
import { DtzxComponent } from './dtzx/dtzx.component';
import { YjzxComponent } from './yjzx/yjzx.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { ZytdItemDetailComponent } from './zytd-item-detail/zytd-item-detail.component';

const routes: Routes = [
  { path: '', redirectTo: '/hmpg', pathMatch: 'full' } , // default url where url is ‘’
  { path: 'hmpg', component: HmpgComponent },
  { path: 'zyly', component: ZylyComponent },
  { path: 'zytd', component: ZytdComponent },
  { path: 'zytd-item-detail/:id', component: ZytdItemDetailComponent },
  { path: 'zytd-item-detail', component: ZytdItemDetailComponent },
  { path: 'jcal', component: JcalComponent },
  { path: 'dtzx', component: DtzxComponent },
  { path: 'yjzx', component: YjzxComponent },
  { path: 'about', component: AboutComponent },
  { path: 'contact', component: ContactComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
